import {AggregateActivity} from "@/lib/types";
import EventActivity from "@/lib/components/EventActivity";
import GroupActivity from "@/lib/components/GroupActivity";

type Props = {
    activity: AggregateActivity,
}

export default function Activity({activity}: Props) {
    if (activity.event) {
        return <EventActivity activity={activity}/>
    } else if (activity.group) {
        return <GroupActivity activity={activity}/>
    } else {
        return null;
    }
};